import React, { useEffect, useState } from "react";
import {
  CustomTable,
  DeleteButton,
  EditButton,
  EditForm,
  MessageBox,
  MotionDiv,
  useTitle,
} from "../../components";
import { useGetAllQueriesQuery, useRespondQueryMutation } from "../../store";
import DeleteQuery from "./DeleteQuery";

const column = [
  "S.No",
  "Name",
  "Message",
  "Response",
  "E-Mail",
  "Date",
  "Actions",
];
const Queries = () => {
  useTitle("Queries");
  const [currentPage, setCurrentPage] = useState(1);
  const [resultPerPage, setResultPerPage] = useState(10);
  const [modalShow, setModalShow] = useState(false);
  const [id, setId] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const { isLoading, isError, error, data } = useGetAllQueriesQuery({
    page: currentPage,
    limit: resultPerPage,
  });
  const [
    sendResponse,
    {
      isLoading: isResponseLoading,
      isSuccess: isResponsesuccess,
      error: responseError,
    },
  ] = useRespondQueryMutation();

  const [info, setInfo] = useState({
    response: "",
  });
  const inputFieldProps = [
    {
      type: "text",
      col: 12,
      row: 8,
      props: {
        name: "response",
        label: "Write Response",
        required: true,
        placeHolder: `Write Response`,
      },
    },
  ];

  const deleteHandler = (id) => {
    setId(id);
    setShowConfirmationModal(true);
  };

  const pageHandler = (p) => setCurrentPage(p);

  const handleResponse = (i) => {
    setId(data?.contacts[i].id);
    setInfo({ response: data?.contacts[i].response });
    setModalShow(true);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    // console.log(info, id);
    sendResponse({ data: info, id });
  };

  const formatDateTime = (dateTimeString) => {
    const dateTime = new Date(dateTimeString);
    const month = dateTime.toLocaleString("default", { month: "short" });
    const day = dateTime.getDate();
    const year = dateTime.getFullYear();
    const time = dateTime.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    return `${day} ${month}, ${year} ${time}`;
  };

  console.log(data?.contacts);
  return (
    <MotionDiv>
      <CustomTable
        loading={isLoading}
        column={column}
        paging={true}
        rowNo={resultPerPage}
        rowProps={{ setResultPerPage }}
        pageProps={{ numOfPages: data?.totalPages, curPage: currentPage }}
        pageHandler={pageHandler}
        search={false}
        isCreateBtn={false}
      >
        {isError ? (
          <MessageBox variant="danger">
            {error?.data?.message}
          </MessageBox>
        ) : (
          data?.contacts.map((query, i) => (
            <>
              <tr key={query.id} className="odd">
                <td className="text-center">{i + 1}</td>
                <td>{query.name}</td>
                <td>{query.message}</td>
                <td>
                  {query.response
                    ? query.response.length > 20
                      ? query.response.substring(0, 20) + "..."
                      : query.response
                    : "---"}
                </td>
                <td>{query.email}</td>
                <td>{formatDateTime(query.created_at)}</td>
                <td>
                  <EditButton onClick={() => handleResponse(i)} />
                  <DeleteButton onClick={() => deleteHandler(query.id)} />
                </td>
              </tr>
            </>
          ))
        )}
        <DeleteQuery
          show={showConfirmationModal}
          onHide={() => setShowConfirmationModal(false)}
          id={id}
        />
      </CustomTable>
      {
        <EditForm
          title="Response"
          data={info}
          setData={setInfo}
          inputFieldProps={inputFieldProps}
          submitHandler={submitHandler}
          successMessage="Responce Sended Successfully!"
          show={modalShow}
          onHide={() => setModalShow(false)}
          reducerProps={{
            loadingUpdate: isResponseLoading,
            success: isResponsesuccess,
            error: responseError,
          }}
        />
      }
    </MotionDiv>
  );
};

export default Queries;
